export default function Marquee({ items, accent = "gold", slow = false }) {
  const color = accent === "red" ? "#9B2226" : "#C99C3A";
  const list = [...items, ...items];
  return (
    <div className="w-full overflow-hidden border-y border-[#F5ECD7]/10 bg-[#121212] py-6">
      <div
        className={`flex whitespace-nowrap ${slow ? "animate-marquee-slow" : "animate-marquee"}`}
      >
        {list.map((t, i) => (
          <span key={i} className="font-display text-3xl md:text-5xl text-[#F5ECD7] tracking-tighter px-8 flex items-center gap-8 shrink-0">
            {t}
            <span className="text-[1.5rem]" style={{ color }}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
